import {MutableRefObject, useEffect, useState} from "react";
import DragHandleIcon from '@mui/icons-material/DragHandle';
import {IconButton} from "@mui/material";
import {useSyncedRef} from "./SyncedRef";

export function DragGrip<T>(props: {
    modifyRef: MutableRefObject<T|null>
    getValue: (ref: T) => number
    setValue: (ref: T, value: number) => void
    onComplete: (value: number) => void

    mode: "vertical-inverse" | "vertical";
}) {
    const [iconRef, setIconRef] = useState<HTMLElement | null>(null);
    const mode = props.mode;
    const getValueRef = useSyncedRef(props.getValue)
    const setValueRef = useSyncedRef(props.setValue)
    const onCompleteRef = useSyncedRef(props.onComplete)
    const modifyRef = props.modifyRef;

    useEffect(() => {
        if(!iconRef) return;

        let startY = 0;
        let startValue = 0;

        const onMouseDown = (e: MouseEvent) => {
            startY = e.clientY;
            startValue = getValueRef.current(modifyRef.current!);

            const onMouseMove = (e: MouseEvent) => {
                const diff = e.clientY - startY;
                if(mode === "vertical-inverse") {
                    setValueRef.current(modifyRef.current!, startValue - diff);
                } else {
                    setValueRef.current(modifyRef.current!, startValue + diff);
                }
            }

            const onMouseUp = () => {
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);

                onCompleteRef.current(getValueRef.current(modifyRef.current!));
            }

            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
        }

        iconRef.addEventListener("mousedown", onMouseDown);

        return () => {
            iconRef.removeEventListener("mousedown", onMouseDown);
        }
    }, [iconRef, mode, getValueRef, modifyRef, onCompleteRef, setValueRef]);

    return (
        <IconButton
            style={{cursor: "ns-resize"}} size="small"
            ref={setIconRef}
        >
            <DragHandleIcon fontSize="inherit" />
        </IconButton>
    )
}